<template>
  <div id="app">
    <Header :isLogin="isLogin" />
    <router-view/>
  </div>
</template>

<script>
import Header from '@/components/Header'
import firebase from 'firebase'

export default {
  name: 'Home',
  data() {
    return {
      isLogin : false,
    }
  },
  components: {
    Header,
  },
  created: function() {
    firebase.auth().onAuthStateChanged((user) => {
      this.isLogin = (user != null);
    })
  }
}
</script>

<style>
@import "./assets/css/basic.css";

</style>
